import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRulesBreaking(options = {}) {
	return _apiRequestWrap(
		ModulesMap.RULES_BREAKING,
		ModulesConfigMap[ModulesMap.RULES_BREAKING].GET_RULES_BREAKING,
		options
	)
}
function _getRuleBreaking(options = {}) {
	return _apiRequestWrap(
		ModulesMap.RULES_BREAKING,
		ModulesConfigMap[ModulesMap.RULES_BREAKING].GET_RULE_BREAKING,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.RULES_BREAKING].GET_RULES_BREAKING]: _getRulesBreaking,
	[ModulesConfigMap[ModulesMap.RULES_BREAKING].GET_RULE_BREAKING]: _getRuleBreaking,

}